import { Box, FormControl, InputLabel } from '@mui/material';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { useSxStyles } from '~/scenes/PortalModules/Analytics/common/ReportDatasetLayout/useStyles';

type PropsType = {
  showHeading?: boolean;
  children: ReactNode;
};

export const ReportDatasetLayout = (props: PropsType) => {
  const { showHeading, children } = props;

  const { t } = useTranslation();
  const sxStyles = useSxStyles();

  return (
    <Box sx={sxStyles.root}>
      {showHeading ? (
        <FormControl>
          <InputLabel shrink={true} focused={false}>
            {t('dataset')}
          </InputLabel>
          <Box sx={sxStyles.content}>{children}</Box>
        </FormControl>
      ) : (
        children
      )}
    </Box>
  );
};
